import { render, staticRenderFns } from "./inputTable.vue?vue&type=template&id=1f5615bc&scoped=true"
import script from "./inputTable.vue?vue&type=script&lang=ts"
export * from "./inputTable.vue?vue&type=script&lang=ts"
import style0 from "./inputTable.vue?vue&type=style&index=0&id=1f5615bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5615bc",
  null
  
)

export default component.exports